$(document).ready(function(){

  $('.featured-blog-slider-wrapper').show();

  $('#create_customer').submit(function(e) {     
  if ( $('input[name="customer[password]"]').val() != $('input[name="customer[password_confirmation]"]').val()) {
    e.preventDefault();
      alert('Passwords do not match.');
    }
  });
  
  $('.product-grid-slider').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });

  $('.logo-box-slider').slick({
    dots: false,
    infinite: true,
    arrows: false,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 3,
    centerMode: true,
    centerPadding: '60px',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }
    ]
  }); 


  $('.banner-grid-for-mobile.mobile-only .banner-grid-mob-slider').slick({
    dots: false,
    infinite: false,
    arrows: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  })
  
  
  mobileOnlySlider(".featuredBlogSlider", false, false, 767);

  function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
    var slider = $($slidername);
    var settings = {
      mobileFirst: true,
      dots: $dots,
      arrows: $arrows,
      responsive: [
        {
          breakpoint: $breakpoint,
          settings: "unslick",
          slidesToShow: 3,
          slidesToScroll: 1
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
      ]
    };
  
    slider.slick(settings);

    $(window).on("resize", function () {
      if ($(window).width() > $breakpoint) {
          return;
      }
      if (!slider.hasClass("slick-initialized")) {
          return slider.slick(settings);
      }
    });
  } // Mobile Only Slider

})

document.addEventListener("DOMContentLoaded", function () {
  const qtyDisplay = document.querySelector(".pd-dd .product__info-container .information.flex span.information__value");

  if (!qtyDisplay) return; // safe exit

  document.addEventListener("change", function (e) {
    if (e.target.matches(".product-form__input__radio")) {
      if (e.target.checked) {
        let qty = e.target.dataset.quantity;

        // Handle if inventory tracking is disabled or undefined
        if (!qty) {
          qty = "N/A";
        }

        // Update quantity display
        qtyDisplay.textContent = qty;
      }
    }
  });
});



